/* ============================================================
   Registrar o service worker na abertura

   Ele faz duas coisas: recebe as notificações em segundo plano e guarda
   a casca do app pra abrir sem internet.

   ANTES ELE SÓ ERA REGISTRADO POR `push.ts`, dentro do fluxo de ligar as
   notificações. Quem instalava e nunca ligava não tinha worker nenhum —
   e portanto abria a tela de dinossauro do Chrome dentro do app da loja
   quando faltava rede.

   O nome do arquivo continua sendo o que o Firebase exige. Um só worker
   por escopo: registrar um segundo em `/` substituiria este.
   ============================================================ */

const ARQUIVO = "/firebase-messaging-sw.js";

export function registrarWorker(): void {
  if (!("serviceWorker" in navigator)) return;

  /* Depois do `load` de propósito: registrar durante a montagem disputa
     banda com o próprio app e atrasa a primeira tela — justamente na
     visita em que a pessoa está decidindo se o app é lento. */
  const registrar = () => {
    void navigator.serviceWorker.register(ARQUIVO, { scope: "/" }).catch(() => {
      // Falhar aqui custa o offline, não o app. Acontece em janela
      // anônima e com armazenamento bloqueado, e não há o que fazer.
    });
  };

  if (document.readyState === "complete") registrar();
  else window.addEventListener("load", registrar, { once: true });
}
